(function () {
  function initSlider(section) {
    if (!section) return;

    // Find the slider element (either direct child or .product-recommendations-slider)
    const slider = section.querySelector(".slider-track");
    if (!slider) return;

    // Find items (try multiple class names for flexibility)
    const cards = section.querySelectorAll(".slider-item");
    if (!cards.length) return;

    // Prevent default image dragging
    cards.forEach((card) => {
      const imgs = card.querySelectorAll("img");
      imgs.forEach((img) =>
        img.addEventListener("dragstart", (e) => e.preventDefault())
      );
    });

    // Find the container for width calculation
    const container = section.querySelector(".slider-container");
    if (!container) return;

    // Find arrow buttons
    const leftArrow = section.querySelector(".slider-left-arrow");
    const rightArrow = section.querySelector(".slider-right-arrow");

    // Create progress track + thumb
    const progressTrack = document.createElement("div");
    const progressThumb = document.createElement("div");
    progressTrack.className = "slider-progress";
    progressThumb.className = "slider-progress-thumb";
    progressTrack.appendChild(progressThumb);
    section.appendChild(progressTrack);

    const cardWidth = cards[0].offsetWidth;
    const visibleWidth = container.offsetWidth;
    const totalContentWidth = cardWidth * cards.length;
    const maxTranslate = Math.min(0, visibleWidth - totalContentWidth); // prevent overscroll

    let isDragging = false;
    let startPos = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;
    let velocity = 0;
    let lastTime = 0;
    let lastPos = 0;
    let clickPrevented = false;
    const clickThreshold = 5; // small movement threshold

    // Helper
    function getPositionX(e) {
      return e.type.includes("mouse") ? e.pageX : e.touches[0].clientX;
    }

    // Start drag
    function startDrag(e) {
      isDragging = true;
      startPos = getPositionX(e);
      lastPos = startPos;
      lastTime = performance.now();
      velocity = 0;
      slider.classList.add("no-transition");
      clickPrevented = false;
    }

    // Handle drag
    function handleDrag(e) {
      if (!isDragging) return;
      const currentTime = performance.now();
      const currentPos = getPositionX(e);
      const deltaX = currentPos - lastPos;
      const deltaTime = currentTime - lastTime;

      if (deltaTime > 0) velocity = deltaX / deltaTime;
      currentTranslate = prevTranslate + (currentPos - startPos);
      const movedDistance = Math.abs(currentPos - startPos);

      // Prevent clicks if user moved more than threshold
      if (movedDistance > clickThreshold) clickPrevented = true;

      // Clamp translate
      currentTranslate = Math.max(maxTranslate, Math.min(0, currentTranslate));
      slider.style.transform = `translateX(${currentTranslate}px)`;

      updateProgress();
      lastPos = currentPos;
      lastTime = currentTime;
    }

    // End drag
    function endDrag() {
      if (!isDragging) return;
      isDragging = false;
      slider.classList.remove("no-transition");

      // Apply a small momentum (damped)
      currentTranslate += velocity * 300; // smaller acceleration
      currentTranslate = Math.max(maxTranslate, Math.min(0, currentTranslate));

      slider.style.transform = `translateX(${currentTranslate}px)`;
      prevTranslate = currentTranslate;

      updateProgress();
    }

    // Progress update
    function updateProgress() {
      const scrollRatio =
        Math.abs(currentTranslate) / Math.abs(maxTranslate || 1);
      const trackWidth = progressTrack.offsetWidth;
      const thumbWidth = progressThumb.offsetWidth;
      const maxThumbMove = trackWidth - thumbWidth;
      progressThumb.style.transform = `translateX(${
        scrollRatio * maxThumbMove
      }px)`;

      // Update arrow states
      updateArrows();
    }

    // Update arrow states
    function updateArrows() {
      if (leftArrow) {
        leftArrow.disabled = currentTranslate >= 0;
      }
      if (rightArrow) {
        rightArrow.disabled = currentTranslate <= maxTranslate;
      }
    }

    // Navigate functions
    function goToNext() {
      if (currentTranslate <= maxTranslate) return;
      const cardWidth = cards[0].offsetWidth;
      const moveBy = Math.min(
        cardWidth,
        Math.abs(currentTranslate - maxTranslate)
      );
      currentTranslate = Math.max(maxTranslate, currentTranslate - moveBy);
      prevTranslate = currentTranslate;
      slider.style.transition = "transform 0.3s ease";
      slider.style.transform = `translateX(${currentTranslate}px)`;
      setTimeout(() => {
        slider.style.transition = "";
      }, 300);
      updateProgress();
    }

    function goToPrev() {
      if (currentTranslate >= 0) return;
      const cardWidth = cards[0].offsetWidth;
      const moveBy = Math.min(cardWidth, Math.abs(currentTranslate));
      currentTranslate = Math.min(0, currentTranslate + moveBy);
      prevTranslate = currentTranslate;
      slider.style.transition = "transform 0.3s ease";
      slider.style.transform = `translateX(${currentTranslate}px)`;
      setTimeout(() => {
        slider.style.transition = "";
      }, 300);
      updateProgress();
    }

    // Event listeners
    slider.addEventListener("mousedown", (e) => {
      if (e.button !== 0) return;
      e.preventDefault();
      startDrag(e);
    });
    slider.addEventListener("mousemove", handleDrag);
    slider.addEventListener("mouseup", endDrag);
    slider.addEventListener("mouseleave", endDrag);

    slider.addEventListener("touchstart", (e) => startDrag(e), {
      passive: true,
    });
    slider.addEventListener("touchmove", (e) => handleDrag(e), {
      passive: true,
    });
    slider.addEventListener("touchend", endDrag);

    // Disable clicks on links when dragging
    slider.addEventListener("click", (e) => {
      if (clickPrevented) e.preventDefault();
    });

    // Arrow navigation
    if (leftArrow) {
      leftArrow.addEventListener("click", goToPrev);
    }
    if (rightArrow) {
      rightArrow.addEventListener("click", goToNext);
    }

    // Update on resize
    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const newCardWidth = cards[0].offsetWidth;
        const newVisibleWidth = container.offsetWidth;
        const newTotalContentWidth = newCardWidth * cards.length;
        maxTranslate = Math.min(0, newVisibleWidth - newTotalContentWidth);
        currentTranslate = Math.max(
          maxTranslate,
          Math.min(0, currentTranslate)
        );
        prevTranslate = currentTranslate;
        slider.style.transform = `translateX(${currentTranslate}px)`;
        updateProgress();
      }, 100);
    });

    updateProgress();
  }

  function initAllSliders() {
    // Find all sections with .slider class
    document.querySelectorAll(".slider").forEach((section) => {
      initSlider(section);
    });
  }

  document.addEventListener("DOMContentLoaded", initAllSliders);

  // Expose function for AJAX-loaded content
  if (typeof window !== "undefined") {
    window.initSlider = initSlider;
  }
})();
